import { bindActionCreators } from 'redux';
import { connect }            from 'react-redux';
import * as actions           from '../../../../redux/modules/actions';
import AddLocation            from './AddLocation';

const mapStateToProps = (state) => {
  return {
    currentView:  state.views.currentView,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions : bindActionCreators(
      {
        enterPage: actions.enterPage,
        leavePage: actions.leavePage,
      },
      dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddLocation);


// WEBPACK FOOTER //
// ./src/app/views/centerportal/crud/addLocation/index.js